/*
 * Author M. Atoar Rahman
 * Title: Partner Stock Receive
 * Description: Index for Partner Stock Receive
 * Date: 22/06/2022
 */

import { Card, Col, Form, Row, Tab, Tabs } from 'react-bootstrap';
import ApprovedD2Table from './ApprovedD2Table';
import { usePartnerStockReceive } from './ContextAPI';
import FormInfo from './FormInfo';
import PendingD2Table from './PendingD2Table';
import PartnerStockReceivePrintIndex from './pdf/PartnerStockReceivePrintIndex';
import ShowModel from './ShowModel';

export default function Index() {
    const { show, formShow, showPdf } = usePartnerStockReceive();
    return showPdf ? (
        <PartnerStockReceivePrintIndex />
    ) : formShow ? (
        <FormInfo />
    ) : (
        <>
            <Card>
                <Card.Header className="cardHeader">
                    <h3>Partner Stock Receive</h3>
                </Card.Header>
                <Card.Body>
                    <Form>
                        <Row className="requisition_table">
                            <Col>
                                <Tabs
                                    defaultActiveKey="pending"
                                    transition={false}
                                    id="noanim-tab-example"
                                    className="mb-3"
                                >
                                    <Tab eventKey="pending" title="Pending">
                                        <PendingD2Table />
                                    </Tab>
                                    <Tab eventKey="approved" title="Received">
                                        <ApprovedD2Table />
                                    </Tab>
                                </Tabs>
                            </Col>
                        </Row>
                    </Form>
                </Card.Body>
            </Card>
            {show && <ShowModel />}
        </>
    );
}
